<template>
  <v-navigation-drawer width="400" v-model="localDrawer" right temporary app>
    <v-list-item :class="localAula.color">
      <v-list-item-content>
        <v-list-item-title class="font-weight-medium">{{
          localAula.tipo_de_aula
        }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>

    <v-divider></v-divider>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Professor (a)</v-list-item-title>
        <p class="font-weight-light text-justify">{{ localAula.professor?.nome }}</p>

        <v-divider></v-divider>

        <v-list-item-title class="mt-4">Data</v-list-item-title>
        <p class="font-weight-light text-justify">
          {{ localAula.data_formatada }} -
          {{ localAula.horario ? localAula.horario.descricao : localAula.dia_da_semana }}
        </p>

        <template v-if="disciplina">
          <div class="mt-4 mb-0">
            <v-list-item-title>
              <strong>Componente Curricular:</strong> {{ disciplina.descricao }}
            </v-list-item-title>
          </div>
        </template>
        <template v-else>
          <div class="mt-4 mb-5">
            <v-list-item-title>Componente(s) Curricular(es)</v-list-item-title>
          </div>

          <div class="mt-n5" v-if="localAula.is_polivalencia == 1">
            <div>
              <div v-for="(item, index) in localAula.polivalencia_formatted" :key="index">
                <v-card elevation="0" class="pa-1 mt-1" style="border: 1px solid #cfd8dc">
                  <div class="pa-2">
                    <span class="font-weight-bold text-uppercase">{{
                      item.disciplina.descricao ?? "- - -"
                    }}</span>

                    <div class="mt-2">
                      <span>Horário: </span>
                      <div>
                        <span class="font-weight-light text-justify" v-if="item.horarios">
                          <div class="ml-4 mb-4">
                            <ul v-for="(horario, index) in item.horarios" :key="index">
                              <li>{{ horario.descricao }}</li>
                            </ul>
                          </div>
                        </span>
                      </div>
                    </div>
                  </div>
                </v-card>
              </div>
            </div>
          </div>

          <div v-if="localAula.is_polivalencia != 1">
            <p
              v-for="(disciplina, index) in localAula.disciplinas_com_descricao"
              :key="index"
              class="font-weight-light text-justify"
            >
              {{ disciplina.descricao ? disciplina.descricao : "- - -" }}
            </p>
          </div>
        </template>

        <div v-for="(item, index) of $constants.listCamposAulasLancadas" :key="index">
          <div v-if="item != 'Conteúdo polivalência'">
            <div v-if="index !== 'campos_de_experiencias'">
              <v-list-item-title v-if="localAula[index]" class="mt-4 mb-5">{{
                item
              }}</v-list-item-title>
              <div v-if="localAula[index]" class="font-weight-light text-justify">
                <div
                  v-html="formatTexto(localAula[index]) ? formatTexto(localAula[index]) : '- - -'"
                ></div>
              </div>
            </div>
            <div v-else>
              <div v-for="(el, idx) of localAula[index]" :key="idx">
                <p v-if="el" class="font-weight-light text-justify">•{{ el }}</p>
              </div>
            </div>
          </div>
        </div>

        <v-divider></v-divider>

        <v-list-item-title class="mt-2">Situação</v-list-item-title>
        <v-list-item-title>
          <v-chip label :color="localAula.color">{{ localAula.descricaoSituacao }}</v-chip>
        </v-list-item-title>

        <div v-if="localAula.e_aula_infantil" class="mt-4">
          <div
            v-for="rotina in localAula.rotinas"
            :key="rotina.id"
            class="mb-8"
            style="background-color: #f3f3f3; padding: 10px; border-radius: 4px"
          >
            <div
              class="text-subtitle-1 font-weight-medium mb-2 d-flex justify-space-between align-center"
            >
              <span>{{ rotina.descricao }}</span>
              <span class="font-weight-light" v-if="rotina.horario_inicial && rotina.horario_final">
                {{ rotina.horario_inicial }} - {{ rotina.horario_final }}
              </span>
            </div>

            <div v-if="rotina.experiencias_labels" class="ml-4 mb-3">
              <div class="font-weight-medium mb-1">Experiências</div>
              <ul class="mt-2 font-weight-light ml-4">
                <li v-for="(label, codigo) in rotina.experiencias_labels" :key="codigo">
                  <strong>{{ codigo }}</strong> – {{ label }}
                </li>
              </ul>
            </div>

            <div v-if="rotina.direitos_aprendizagem?.length" class="ml-4 mb-3">
              <div class="font-weight-medium mb-1">Direitos de Aprendizagem</div>
              <ul class="font-weight-light ml-4">
                <li v-for="(direito, idx) in rotina.direitos_aprendizagem" :key="idx">
                  {{ direito }}
                </li>
              </ul>
            </div>

            <div v-if="rotina.campos_experiencia_aula?.length" class="ml-4 mb-3">
              <div class="font-weight-medium mb-1">Campos de Experiências</div>
              <ul class="font-weight-light ml-4">
                <li v-for="(campo, idx) in rotina.campos_experiencia_aula" :key="idx">
                  {{ campo }}
                </li>
              </ul>
            </div>

            <div v-if="rotina.objetivos_aprendizagem" class="ml-4">
              <div class="font-weight-medium mb-1">Objetivos de Aprendizagem e Desenvolvimento</div>
              <p class="font-weight-light ml-4">{{ rotina.objetivos_aprendizagem }}</p>
            </div>

            <div v-if="rotina.orientacoes_metodologicas" class="ml-4">
              <div class="font-weight-medium mb-1">Orientações / Metodológicas</div>
              <p class="font-weight-light ml-4">{{ rotina.orientacoes_metodologicas }}</p>
            </div>

            <div v-if="rotina.recursos" class="ml-4">
              <div class="font-weight-medium mb-1">Recursos</div>
              <p class="font-weight-light ml-4">{{ rotina.recursos }}</p>
            </div>
          </div>

          <div style="background-color: #f3f3f3; padding: 10px; border-radius: 4px">
            <div class="font-weight-medium mb-1">Avaliação</div>
            <p class="font-weight-light ml-4">{{ localAula.avaliacao }}</p>
          </div>
        </div>

        <div v-else>
          <v-list-item-title class="mt-4">Unidades Temáticas</v-list-item-title>
          <p
            v-if="unidadesTematicasTexto"
            class="font-weight-light"
            v-html="formatTexto(unidadesTematicasTexto)"
          ></p>
          <p v-else class="font-weight-light">Sem Unidades Temáticas cadastradas.</p>

          <v-list-item-title class="mt-4">Objetos de Conhecimento</v-list-item-title>
          <p
            v-if="objetosConhecimentoTexto"
            class="font-weight-light"
            v-html="formatTexto(objetosConhecimentoTexto)"
          ></p>
          <p v-else class="font-weight-light">Sem Objetos de Conhecimento cadastradas.</p>

          <v-list-item-title class="mt-4">Habilidades</v-list-item-title>
          <p
            v-if="habilidadesTexto"
            class="font-weight-light"
            v-html="formatTexto(habilidadesTexto)"
          ></p>
          <p v-else class="font-weight-light">Sem habilidades cadastradas.</p>

          <v-list-item-title class="mt-4">Objetivos de Aprendizagem</v-list-item-title>
          <p
            v-if="objetivosDeAprendizagemTexto"
            class="font-weight-light"
            v-html="formatTexto(objetivosDeAprendizagemTexto)"
          ></p>
          <p v-else class="font-weight-light">Sem Objetos de Aprendizagem cadastradas.</p>

          <v-list-item-title class="mt-4">Procedimentos Metodológicos</v-list-item-title>
          <p
            v-if="procedimentosMetodologicosTexto"
            class="font-weight-light"
            v-html="formatTexto(procedimentosMetodologicosTexto)"
          ></p>
          <p v-else class="font-weight-light">Sem Procedimentos Metodológicos cadastradas.</p>

          <v-list-item-title class="mt-4">Material de Apoio</v-list-item-title>
          <p
            v-if="materialDeApoioTexto"
            class="font-weight-light"
            v-html="formatTexto(materialDeApoioTexto)"
          ></p>
          <p v-else class="font-weight-light">Sem Material de Apoio cadastradas.</p>

          <v-list-item-title class="mt-4">Avaliação da Aula</v-list-item-title>
          <p
            v-if="localAula.avaliacao_da_aula"
            class="font-weight-light"
            v-html="formatTexto(localAula.avaliacao_da_aula)"
          ></p>
          <p v-else class="font-weight-light">Sem Avaliação da Aula</p>
        </div>
      </v-list-item-content>
    </v-list-item>
  </v-navigation-drawer>
</template>

<script>
export default {
  props: {
    value: { type: Boolean, required: true },
    aula: { type: Object, required: true },
    disciplina: { type: Object, required: false },
  },
  data() {
    return { localDrawer: this.value };
  },
  computed: {
    localAula() {
      return this.aula;
    },
    parsedHabilidades() {
      const parsed = this.tryParseHabilidades(this.localAula.habilidades);
      return parsed || [];
    },
    uniqueUnidadesTematicas() {
      if (this.parsedHabilidades.length > 0) {
        const unidades = this.parsedHabilidades.map((h) => h.unidades_tematicas).filter(Boolean);
        return [...new Set(unidades)];
      }
      return [];
    },
    uniqueObjetosConhecimento() {
      if (this.parsedHabilidades.length > 0) {
        const objetos = this.parsedHabilidades.map((h) => h.objeto_conhecimento).filter(Boolean);
        return [...new Set(objetos)];
      }
      return [];
    },
    uniqueMaterialDeApoio() {
      if (this.parsedHabilidades.length > 0) {
        const objetos = this.parsedHabilidades.map((h) => h.material_de_apoio).filter(Boolean);
        return [...new Set(objetos)];
      }
      return [];
    },
    uniqueAvaliacao() {
      if (this.parsedHabilidades.length > 0) {
        const objetos = this.parsedHabilidades.map((h) => h.avaliacao_da_aula).filter(Boolean);
        return [...new Set(objetos)];
      }
      return [];
    },
    uniqueObjetivosAprendizagem() {
      if (this.parsedHabilidades.length > 0) {
        const objetos = this.parsedHabilidades
          .map((h) => h.objetivo_de_aprendizagem)
          .filter(Boolean);
        return [...new Set(objetos)];
      }
      return [];
    },
    uniqueProcedimentosMetodologicos() {
      if (this.parsedHabilidades.length > 0) {
        const objetos = this.parsedHabilidades
          .map((h) => h.procedimentos_metodologicos)
          .filter(Boolean);
        return [...new Set(objetos)];
      }
      return [];
    },
    uniqueHabilidades() {
      if (this.parsedHabilidades.length > 0) {
        const objetos = this.parsedHabilidades.map((h) => h.habilidade).filter(Boolean);
        return [...new Set(objetos)];
      }
      return [];
    },
    unidadesTematicasTexto() {
      if (this.localAula.unidades_tematicas) return this.localAula.unidades_tematicas;
      if (this.uniqueUnidadesTematicas.length > 0) return this.uniqueUnidadesTematicas.join("\n");
      return "";
    },
    objetosConhecimentoTexto() {
      if (this.localAula.objeto_conhecimento) return this.localAula.objeto_conhecimento;
      if (this.uniqueObjetosConhecimento.length > 0)
        return this.uniqueObjetosConhecimento.join("\n");
      return "";
    },
    materialDeApoioTexto() {
      if (this.localAula.material_de_apoio) return this.localAula.material_de_apoio;
      if (this.uniqueMaterialDeApoio.length > 0) return this.uniqueMaterialDeApoio.join("\n");
      return "";
    },
    avaliacaoTexto() {
      if (this.localAula.avaliacao_da_aula) return this.localAula.avaliacao_da_aula;
      if (this.uniqueAvaliacao.length > 0) return this.uniqueAvaliacao.join("\n");
      return "";
    },
    objetivosDeAprendizagemTexto() {
      if (this.localAula.objetivo_de_aprendizagem) return this.localAula.objetivo_de_aprendizagem;
      if (this.uniqueObjetivosAprendizagem.length > 0)
        return this.uniqueObjetivosAprendizagem.join("\n");
      return "";
    },
    procedimentosMetodologicosTexto() {
      if (this.localAula.procedimentos_metodologicos)
        return this.localAula.procedimentos_metodologicos;
      if (this.uniqueProcedimentosMetodologicos.length > 0)
        return this.uniqueProcedimentosMetodologicos.join("\n");
      return "";
    },
    habilidadesTexto() {
      if (this.localAula.habilidades) return this.localAula.habilidades;
      if (this.uniqueHabilidades.length > 0) return this.uniqueHabilidades.join("\n");
      return "";
    },
  },
  watch: {
    value() {
      this.localDrawer = this.value;
    },
    localDrawer() {
      this.$emit("input", this.localDrawer);
    },
  },
  methods: {
    formatarConteudo(conteudo) {
      if (!conteudo) return "";
      return conteudo.replace(/\n/g, "<br>");
    },
    formatTexto(texto) {
      const textoSemColchetes = texto.replace(/\[|\]/g, "");
      const textoSemQuebraDeLinha = textoSemColchetes.replace(/\\n/g, " ").replace(/"/g, "");
      const textoFormatado = textoSemQuebraDeLinha.replace(/\n/g, "<br>");
      return textoFormatado.trim() || "- - -";
    },
    tryParseHabilidades(valor) {
      if (Array.isArray(valor)) return valor;
      if (typeof valor !== "string") return null;
      const trimmed = valor.trim();
      if (!trimmed.startsWith("[") || !trimmed.endsWith("]")) return null;
      try {
        const parsed = JSON.parse(trimmed);
        return Array.isArray(parsed) ? parsed : null;
      } catch (error) {
        return null;
      }
    },
  },
};
</script>

<style scoped>
.text-justify,
p,
div {
  word-break: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}
</style>
